import { useEffect, useRef, useState } from 'react';

function useFilterInfo(stores?: StoreHomeV2.NoReceptionStore[]) {
  const [filters, setFilters] = useState<{
    platforms: General.PlatformUpperCaseTunnel[];
    regions: General.UpperCaseRegion[];
  }>({ platforms: [], regions: [] });
  const hasData = useRef<boolean>(false);

  useEffect(() => {
    if (stores) {
      if (!hasData.current) {
        setFilters({
          platforms: [...new Set(stores.map((store) => store.externalType))],
          regions: [...new Set(stores.map((store) => store.region))],
        });
        hasData.current = true;
      }
    }
  }, [stores]);

  return filters;
}

export default useFilterInfo;
